import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import resources from './resources'

// @ts-ignore - unused for now but may be needed for debug configuration
const IS_DEV = !process.env.ENVIRONMENT || process.env.ENVIRONMENT === 'dev'

// RTL languages configuration
export const RTL_LANGUAGES = ['ar']
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'ar', 'es']

// Language configuration with display names
export const LANGUAGE_CONFIG = {
  en: { name: 'English', nativeName: 'English', dir: 'ltr' },
  fr: { name: 'French', nativeName: 'Français', dir: 'ltr' },
  ar: { name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  es: { name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      nestingOptionsSeparator: '.',
      escapeValue: false,
    },
    resources,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

// Set HTML dir attribute when language changes
i18n.on('languageChanged', (lng: string) => {
  const direction = LANGUAGE_CONFIG[lng as keyof typeof LANGUAGE_CONFIG]?.dir || 'ltr'
  document.documentElement.dir = direction
  document.documentElement.lang = lng

  // Force re-render of React components by updating the data-lang attribute
  // This helps components that might not be properly subscribed to i18n changes
  document.body.setAttribute('data-language', lng)
  document.body.setAttribute('data-direction', direction)

  // Dispatch a custom event for any components that need to listen
  window.dispatchEvent(
    new CustomEvent('i18nLanguageChanged', {
      detail: { language: lng, direction },
    })
  )
})

export default i18n
